import { render, staticRenderFns } from "./CustomInfiniteLoader.vue?vue&type=template&id=96cabba6&"
import script from "./CustomInfiniteLoader.vue?vue&type=script&lang=ts&"
export * from "./CustomInfiniteLoader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomInfiniteLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports